import React, { useEffect,useState,useRef } from 'react'
import {Link}  from "react-router-dom"
import CarSummary from './components/CarSummary'
import { useAuth } from '../contexts/AuthContext'
import MenuBar from '../layouts/MenuBar'
import LapSummary from './components/LapSummary'
import { doc, getDoc,collection,query,where,getDocs, orderBy,updateDoc } from "firebase/firestore";
import { db } from '../firebase'

import LocationMap from './components/LocationMap'
import { elapsedTimeIntoValue } from '../utils/TimeFunctions'
import { useDatabase } from '../contexts/DatabaseContext'
import elapsedTimeIntoString from '../utils/TimeFunctions'
import { useTelemetry } from '../contexts/TelemetryContext'

export default function HomePage() {
  // UI State
  const [errorFetching, setErrorFetching] = useState()
  const [resetButton,setResetButton] = useState('btn-primary')


  // Providers
  const { currentUser } = useAuth()
  const { userSettings, carsSettings, elapsedRaceTime } = useDatabase()
  const { telemetry, latestTelemetry } = useTelemetry()

  // Database References
  const userRef = doc(db, "users", currentUser.uid);


  const [carInPit,setCarInPit] = useState(false) // state to track if the car is in the pit or not
 
  // Race reset
function handleReset(e){
  if (resetButton === 'btn-primary') {
    setResetButton('btn-danger') // Make it scary to confirm
  } else {
    setResetButton('btn-primary') // If its already scary then confirm it and reset
    updateDoc(userRef, {race_start_time: null}, {merge: true}) // Save this reset to firebase also
}
}

// when a primed reset button is clicked off of it will put the button back to its normal condition
function handleUnfocusReset(e){
  setResetButton('btn-primary')
}

function handleStart(e){
  // Writes the start time to local settings
  const currentTime=Date.now()
  updateDoc(userRef, {race_start_time: currentTime}, {merge: true})
}

  return (
    <>
      
    <MenuBar />
    <h2 className="home-page-card--title py-3">{currentUser.displayName} Dashboard</h2>
    {errorFetching>8 && 
    <div className="alert alert-warning mx-2 d-flex flex-column homepage-dash ">
      <p className="text-center">Unable to fetch data from car.</p>
      <div className="m-auto">
      <ul>
        <li>Dweet Thing name may be inputted incorrectly.</li>
        <li>Check that Dweet Thing is receiving data from car.</li>
      </ul>
      </div>
    </div>}
    
    <div className="d-flex homepage-dash flex-column">
      {(carsSettings) ? carsSettings.map((car,index) => (
      <CarSummary 
        name={'Car '+(index+1)+': '+car.car_name} 
        telemetry={latestTelemetry?.[car.dweet_name] || null} 
        settings={car}
        userSettings={userSettings}
        index={index}/>))
    :
    
    <div className="spinner-border text-primary m-auto" role="status">
      <span className="visually-hidden">Loading Cars...</span>
    </div>
      }
      <br></br>
      <div className="card-dash car-summary border rounded-3" id="raceTimer">
        <div className="card-header">
            <h3 className="card-title mt-1 text-center">Race {userSettings?.race_start_time && elapsedTimeIntoString(elapsedRaceTime)}</h3>
        </div>
        <div className="card-body">
          <progress className="progress" min="0" max={userSettings?.race_length} value={userSettings?.race_start_time ? (elapsedRaceTime)/1000/60 : 0} ></progress>
          <div className="btn-group w-100 mt-2">
            <button disabled={userSettings?.race_start_time} onClick={handleStart} className="btn btn-primary btn-block ">Start</button>
            <button disabled={!userSettings?.race_start_time} onClick={handleReset} onBlur={handleUnfocusReset} className={"btn btn-block "+resetButton} >Reset</button>
            <Link to="/configure?2" className="btn btn-primary btn-block">Setup</Link>
          </div>
        </div>
    </div>
      {/*
    <div class="card car-summary" id="raceTimer" hidden>
          <div class="card-header">
              <h3 class="card-title mt-1 text-center">Pit Stop</h3>      
          </div>
          <div class="card-body">
              <h3>{userSettings?.totalPitTime/1000}s</h3>
              <div class="btn-group w-100 mt-2">
                  
                  <button onClick={handleCarInPit} class="btn btn-primary btn-block ">Car In Pit</button>
                  
                  <button disabled={!settings?.carInPit} onClick={handleCarLeftPit}class="btn btn-primary btn-block">Car Left Pit</button>
                  
                  <button onClick={resetPitTimes} className="btn btn-primary btn-block">Reset</button>
              </div>
          </div>
      </div>*/}

      <br></br>
   
      {latestTelemetry &&
      <LocationMap telemetry={latestTelemetry} /> }
        
      
     
      </div>
    </>
  )
}


// <DataLastReceived time={dataLastReceived}/>
// 
// <RacePanel />
// {settings.raceLength}
// (raceTime < settings.raceLength) ? raceTime : settings.raceLength+':00'}

// make setup button go to settings page in the race data section
/*


{userSettings?.dweet_name && <DataLastReceived time={dataLastReceived}/>}
return (
  <div class="card car-summary" id="raceTimer">
      <div class="card-header">
          <h3 class="card-title mt-1 text-center">Race {(raceTime < settings.raceLength) ? raceTime : settings.raceLength+':00'}</h3>
      </div>
      <div class="card-body">
          <progress class="progress" min="0" max={settings.raceLength} value={raceTimeValue} ></progress>
          <div class="btn-group w-100 mt-2">
              <button disabled={raceStart} onClick={handleStart} class="btn btn-primary btn-block ">Start</button>
              <button onClick={handleReset} onBlur={handleUnfocusReset} class={"btn btn-block "+resetButton} >Reset</button>
              <Link to="/configure?2" class="btn btn-primary btn-block">Setup</Link>
          </div>
      </div>
  </div>
)
}*/
// value={elapsedTimeIntoValue}